module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "squares"
  }, [_c('ul', {
    staticClass: "list_pic clearfix"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      directives: [{
        name: "handle-hover",
        rawName: "v-handle-hover"
      }],
      key: item.goodsId,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "goods-content"
    }, [_c('div', {
      staticClass: "goods-pic"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": item.name
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "goods-info"
    }, [_c('div', {
      staticClass: "goods-pic-scroll-show"
    }, [_c('div', {
      staticClass: "ul"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "height": "28",
        "width": "28",
        "border": "0"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "goods-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('em', {
      staticClass: "sale-price",
      attrs: {
        "title": '原价：¥' + item.mktPrice
      }
    }, [_vm._v(_vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "sell-stat"
    }, [_c('ul', [_c('li', [_c('a', {
      staticClass: "status",
      attrs: {
        "href": "javascript:void(0)",
        "onclick": "return false;"
      }
    }, [_vm._v(_vm._s(item.buyNum ? item.buyNum : 0))]), _vm._v(" "), _c('p', [_vm._v("商品销量")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "onclick": "return false;"
      }
    }, [_vm._v(_vm._s(item.commentNum ? item.commentNum : 0))]), _vm._v(" "), _c('p', [_vm._v("用户评论")])])])]), _vm._v(" "), _c('div', {
      staticClass: "store"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: item.storeId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                店铺：" + _vm._s(item.storeName) + "\n              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "add-cart"
    }, [_c('a', {
      staticClass: "add_cart",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.cAddCart(item.goodsId)
        }
      }
    }, [_vm._v("加入菜篮")]), _vm._v(" "), _c('a', {
      staticClass: "buynow",
      attrs: {
        "href": "javascript:void(0);",
        "title": "立即购买"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.buynow(item.goodsId, item.storeId, item)
        }
      }
    }, [_vm._v(" 立即购买\n              ")])])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total>0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.pageNo,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "update:current": function($event) {
        _vm.pageNo = $event
      },
      "on-change": _vm.changePage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-879b778e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fresh-agricultural/content-item.vue
// module id = 1650
// module chunks = 1